import { useTableActionContext } from '@aibees/elephant/context';
import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { useMemo } from 'react';
import { convertOptionsToTemplateCategories } from '../utils/options-converter';

export const useExportOptions = () => {
  const { data } = useBootstrapApi();
  // Use the flow's effective search type (folds in the ActionButton override) so
  // the column options match the record, not just the page route.
  const { integrationConfig, effectiveSearchType } = useTableActionContext();

  const templateCategories = useMemo(() => {
    const titles = data?.export.titles || {};
    return convertOptionsToTemplateCategories(
      titles,
      integrationConfig,
      effectiveSearchType
    );
  }, [data?.export.titles, integrationConfig, effectiveSearchType]);
  const companyOptions = useMemo(() => {
    return templateCategories.find(
      (i) => i.key.toLocaleLowerCase() === 'company'
    );
  }, [templateCategories]);

  const emailOptions = useMemo(() => {
    return templateCategories.find(
      (i) => i.key.toLocaleLowerCase() === 'email'
    );
  }, [templateCategories]);

  const peopleOptions = useMemo(() => {
    return templateCategories;
  }, [templateCategories]);

  return {
    companyOptions,
    peopleOptions,
    emailOptions,
  };
};
